var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeferredBillingPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.71 2.12c.47 0 .85.38.85.85v1.66h6.88V2.97a.85.85 0 0 1 1.7 0v1.66h2.3a2.75 2.75 0 0 1 2.75 2.75v6.01a.85.85 0 1 1-1.7 0v-1.85H3.52v7.59c0 .58.47 1.05 1.05 1.05h4.54a.85.85 0 0 1 0 1.7H4.57a2.75 2.75 0 0 1-2.75-2.75V7.38a2.75 2.75 0 0 1 2.75-2.75h2.29V2.97c0-.47.38-.85.85-.85m-.85 4.21H4.57c-.58 0-1.05.47-1.05 1.05v2.46h16.97V7.38c0-.58-.47-1.05-1.05-1.05h-2.3v1.78a.85.85 0 1 1-1.7 0V6.33H8.56v1.78a.85.85 0 0 1-1.7 0zm9.071 8.76a.85.85 0 0 1 0 1.201l-1.219 1.219h6.618a.85.85 0 0 1 0 1.7h-6.618l1.22 1.219a.85.85 0 1 1-1.203 1.202l-2.67-2.67a.85.85 0 0 1 0-1.202l2.67-2.67a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgDeferredBillingPayment;